import { render, staticRenderFns } from "./card-swiper.vue?vue&type=template&id=9bbdcbd4&"
import script from "./card-swiper.vue?vue&type=script&lang=js&"
export * from "./card-swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports